import { Mastered, Section, Studying, Tech } from "./styles"
import { techsMastered, techsStudying } from "./techs";
export default function Technologies(props) {



  return (
    <Section>

      <h2 >Tecnologias Aprendidas</h2>
      <Mastered>
        {techsMastered.map(tech => <Tech
          key={tech.name}
          path={tech.url}>
          <div></div>
        </Tech>)}
      </Mastered>

      <h2 >Aprendendo</h2>

      <Studying>
        {techsStudying.map(tech => <Tech
          key={tech.name}
          path={tech.url}>
          <div></div>
        </Tech>)}
      </Studying>

    </Section>
  );
}
